import React from 'react';
import classnames from 'classnames';

import { useId } from '@fluentui/react-hooks';
import { mergeStyleSets, FontSizes, FontWeights, Icon } from '@fluentui/react';
import { CommandIcon, CommandIconPlaceholder } from 'src/components/base/CommandIcon';
import TeachingCoachmark from 'src/components/base/TeachingCoachmark';

import { asArray } from 'shared/utils/utils';


export const classNames = mergeStyleSets({
  listItemLink: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',

    padding: '0px 16px 0px 16px',
    color: '#666666',
    textDecoration: 'none',
    minHeight: 60,
    maxWidth: '100%',
    cursor: 'default',

    selectors: {
      ':hover': {
        backgroundColor: '#f3f3f3',
        '> div:nth-child(2)': {
          display: 'flex'
        },
      },
      '> div:nth-child(2)': {
        display: 'none',
      },
    },
  },

  selectedItem: {
    backgroundColor: '#eaeaea'
  },

  listItem: {
    flex: '1 1 auto',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',

    selectors: {
      '&>.title': {
        fontSize: FontSizes.medium,
        fontWeight: FontWeights.regular,
        color: '#333',
        textOverflow: 'inherit',
        overflow: 'inherit',
      },
      '&>.subtitle': {
        fontSize: FontSizes.small,
        color: '#666',
        textOverflow: 'inherit',
        overflow: 'inherit',
      },
    }
  },

  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
  },
})


export function ItemLabel({ title = '', subtitle = '', className = '', styles = {} }) {
  const { root = {}, title: titleStyle = {}, subtitle: subtitleStyle = {} } = styles;

  const subtitles = asArray(subtitle).filter(Boolean);
  return (
    <div className={classnames(classNames.listItem, className)} style={root}>
      <div className="title" style={titleStyle}>{title}</div>
      { subtitles.map((subtitle, index) => 
        <div key={index} className="subtitle" style={subtitleStyle}>{subtitle}</div>)
      }
    </div>
  );
}

export function ListItem({ title, subtitle, styles = {}, className = '', buttons = [], isSelected = false, showLinkChevron = false, teaching, onClick }) {
  const { root = {}, label = {}, buttons: buttonsStyle = {} } = styles;
  const itemId = useId();

  return (
    <div id={itemId} className={classnames(classNames.listItemLink, className, { [classNames.selectedItem]: isSelected })} 
      style={root} onClick={(event) => onClick?.(event) }
    >
      <ItemLabel title={title} subtitle={subtitle} style={label} styles={styles} />
      { !!buttons.length && 
        <div className={classNames.buttonsContainer} style={buttonsStyle}>
          { buttons.map((x, index) => x
            ? <CommandIcon key={index} {...x} />
            : <CommandIconPlaceholder key={index}/>)
          }
        </div>
      }
      { teaching && <TeachingCoachmark target={itemId} {...teaching} />}
      { showLinkChevron && <Icon iconName='ChevronRight' /> }
    </div>
  );
}


export default ListItem;